import { THREE } from '@powerplay/common';
import { ParticleMaterialType } from './types';
import { ParticleEmitter } from './ParticleEmitter';
export class ParticleSystem {
    emitterArray = [];
    defaultParticleSettings = {
        emitRate: 10,
        particleLife: 300,
        blending: THREE.AdditiveBlending,
        depthTest: true,
        depthWrite: false,
        transparent: true,
        vertexColors: true,
        position: new THREE.Vector3(),
        materialType: ParticleMaterialType.points,
        color: undefined,
        alphaMap: undefined,
        size: 1.0,
        sizeAttenuation: undefined,
        gravitation: true,
        randomizeRotationDir: false,
        randomDrift: true,
        randomPower: 0.5,
        basePosition: new THREE.Vector3(0, 0, 0),
        particleSpan: new THREE.Vector3(10, 10, 10),
        particleAmountPerEmit: 10,
        alpha: 1.0,
        scale: 1.0,
        velocity: new THREE.Vector3(0, 0, 0),
        velocitySlowDown: undefined,
        easeValues: undefined,
        rotation: 0,
        rotationCoefs: 0,
        rotationDir: 1,
        maxParticleAmount: 10000,
        mass: 0,
        repeat: [1, 1],
        offset: [1, 1],
        fpsLimit: 30,
        width: 1920,
        height: 1080
    };
    getDefaultParticleSettings() {
        return this.defaultParticleSettings;
    }
    setUpEmitter(optionObject) {
        if (!optionObject.scene || !optionObject.name) {
            throw new Error('You must specify a scene and a name for partikle');
        }
        const optionsCopy = { ...optionObject };
        this.provideDefaults(optionsCopy);
        const emitter = this.createEmitter(optionsCopy);
        this.emitterArray.push(emitter);
    }
    getParticleEmitter(name) {
        const emitterArray = this.emitterArray.filter(emitter => (emitter.getName() === name));
        if (emitterArray[0])
            return emitterArray[0];
        throw new Error('Emitter undefined');
    }
    checkActivateEmitters(quality) {
        this.emitterArray.forEach((emitter) => {
            const shouldBeEnabled = quality >= emitter.minSettingsQualityForRender;
            if (emitter.enabled === shouldBeEnabled)
                return;
            emitter.enabled = shouldBeEnabled;
            if (shouldBeEnabled) {
                if (!emitter.oneTimeEffect)
                    emitter.startEmitter();
            }
            else {
                emitter.stopEmitter();
            }
        });
    }
    stopEmitters() {
        this.emitterArray.forEach(emitter => emitter.stopEmitter());
    }
    startEmitters() {
        this.emitterArray.forEach(emitter => emitter.startEmitter());
    }
    update() {
        if (this.emitterArray.length === 0)
            return;
        this.updateEmitters();
    }
    updateEmitters() {
        this.emitterArray.forEach(emitter => emitter.update());
    }
    createEmitter(optionsCopy) {
        return new ParticleEmitter(optionsCopy);
    }
    provideDefaults(optionsCopy) {
        const { emitRate, particleLife, blending, depthTest, depthWrite, transparent, vertexColors, position, gravitation, randomizeRotationDir, randomDrift, randomPower, basePosition, particleSpan, particleAmountPerEmit, alpha, scale, velocity, velocitySlowDown, easeValues, rotation, rotationCoefs, rotationDir, maxParticleAmount, mass, repeat, offset, fpsLimit, height, width } = this.defaultParticleSettings;
        if (optionsCopy.emitRate === undefined)
            optionsCopy.emitRate = emitRate;
        if (optionsCopy.particleLife === undefined)
            optionsCopy.particleLife = particleLife;
        if (optionsCopy.blending === undefined)
            optionsCopy.blending = blending;
        if (optionsCopy.depthTest === undefined)
            optionsCopy.depthTest = depthTest;
        if (optionsCopy.depthWrite === undefined)
            optionsCopy.depthWrite = depthWrite;
        if (optionsCopy.transparent === undefined)
            optionsCopy.transparent = transparent;
        if (optionsCopy.vertexColors === undefined)
            optionsCopy.vertexColors = vertexColors;
        if (optionsCopy.position === undefined)
            optionsCopy.position = position;
        if (optionsCopy.basePosition === undefined)
            optionsCopy.basePosition = basePosition;
        if (optionsCopy.particleSpan === undefined)
            optionsCopy.particleSpan = particleSpan;
        if (optionsCopy.particleAmountPerEmit === undefined) {
            optionsCopy.particleAmountPerEmit = particleAmountPerEmit;
        }
        if (optionsCopy.alpha === undefined)
            optionsCopy.alpha = alpha;
        if (optionsCopy.scale === undefined)
            optionsCopy.scale = scale;
        if (optionsCopy.gravitation === undefined)
            optionsCopy.gravitation = gravitation;
        if (optionsCopy.randomizeRotationDir === undefined)
            optionsCopy.randomizeRotationDir = randomizeRotationDir;
        if (optionsCopy.randomDrift === undefined)
            optionsCopy.randomDrift = randomDrift;
        if (optionsCopy.randomPower === undefined)
            optionsCopy.randomPower = randomPower;
        if (optionsCopy.velocity === undefined)
            optionsCopy.velocity = velocity;
        if (optionsCopy.velocitySlowDown === undefined)
            optionsCopy.velocitySlowDown = velocitySlowDown;
        if (optionsCopy.easeValues === undefined)
            optionsCopy.easeValues = easeValues;
        if (optionsCopy.rotation === undefined)
            optionsCopy.rotation = rotation;
        if (optionsCopy.rotationCoefs === undefined)
            optionsCopy.rotationCoefs = rotationCoefs;
        if (optionsCopy.rotationDir === undefined)
            optionsCopy.rotationDir = rotationDir;
        if (optionsCopy.maxParticleAmount === undefined) {
            optionsCopy.maxParticleAmount = maxParticleAmount;
        }
        if (optionsCopy.mass === undefined)
            optionsCopy.mass = mass;
        if (optionsCopy.repeat === undefined)
            optionsCopy.repeat = repeat;
        if (optionsCopy.offset === undefined)
            optionsCopy.offset = offset;
        if (optionsCopy.fpsLimit === undefined)
            optionsCopy.fpsLimit = fpsLimit;
        if (optionsCopy.height === undefined)
            optionsCopy.height = height;
        if (optionsCopy.width === undefined)
            optionsCopy.width = width;
    }
}
//# sourceMappingURL=ParticleSystem.js.map